// auth.service.ts
import { Injectable } from '@angular/core';
import { HttpClient,HttpParams, HttpResponse, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { LoginResponse } from '../models/user';
import { Router } from '@angular/router';
import * as jwt_decode from 'jwt-decode';
import * as actionSession from '../../core/actions/session.actions';
import { Store } from '@ngrx/store';
import { Role } from '../models/role';
import { BaseService } from './base.service';


@Injectable({
  providedIn: 'root'
})
export class RoleService extends BaseService {

  getAll(): Observable<Role[]> {
    return this.http
      .get<Role[]>(this.basePath + '/v1/roles')
      .pipe(
        catchError(this.handleError)
      );
  }
}
